export const MARKET_MAP_DATA = "MARKET_MAP_DATA";
export const OVERVIEW_HOLDING_DATA = "OVERVIEW_HOLDING_DATA";
export const ALERTS_OVERVIEW = "ALERTS_OVERVIEW";
export const HOLDING_DATA = "HOLDING_DATA";
